import { Stack } from 'expo-router';

export default function SeeAllOffersLayout() {
  return (
    <Stack
      screenOptions={{
        title: 'See All Offers',
        headerShown: false,
      }}
    />
  );
}
